export const StorageKeys = {
  AppToken: 'app:token',
  CreatedEdgeQuote: 'created-edge-quote',
  CreatedAdhocQuote: 'created-adhoc-quote'
}

export const getToken = () => {
  const token = localStorage.getItem(StorageKeys.AppToken)
  return token ? JSON.parse(token) : { value: '', exp: 0 }
}

export const saveToken = (token, exp) => {
  return localStorage.setItem(StorageKeys.AppToken, JSON.stringify({ value: token, exp }))
}

export const clearToken = () => {
  return localStorage.removeItem(StorageKeys.AppToken)
}

export const getLocalStorageItem = (key) => {
  const data = localStorage.getItem(key)
  return data ? JSON.parse(data) : null
}

export const saveLocalStorageItem = (key, data) => {
  return localStorage.setItem(key, JSON.stringify(data))
}

export const clearLocalStorageItem = (key) => {
  return localStorage.removeItem(key)
}
